"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var TutorialInfo_1 = require("./TutorialInfo");
var GameConstants_1 = require("../GameConstants");
var GameVars_1 = require("../GameVars");
var AudioManager_1 = require("../AudioManager");
var TutorialLayer = /** @class */ (function (_super) {
    __extends(TutorialLayer, _super);
    function TutorialLayer(game) {
        var _this = _super.call(this, game, null, "tutorial-layer") || this;
        _this.index = 0;
        var background = new Phaser.Image(_this.game, GameConstants_1.GameConstants.GAME_WIDTH / 2, GameConstants_1.GameConstants.GAME_HEIGHT / 2, "bg");
        background.anchor.set(.5);
        background.inputEnabled = true;
        background.events.onInputDown.add(function () {
            // 
        }, _this);
        _this.add(background);
        var exitButton = new Phaser.Button(_this.game, 10, 10, "texture_atlas_1", function () {
            AudioManager_1.AudioManager.getInstance().playSound("btn_press");
            _this.destroy();
        }, _this);
        exitButton.setFrames("btn_back_next", "btn_back_next", "btn_back_next");
        exitButton.scale.y = GameVars_1.GameVars.scaleY;
        exitButton.input.pixelPerfectOver = true;
        exitButton.forceOut = true;
        _this.add(exitButton);
        var title = new Phaser.Image(_this.game, GameConstants_1.GameConstants.GAME_WIDTH / 2, 20, "texture_atlas_1", "txt_tutorial");
        title.anchor.set(.5, 0);
        title.scale.y = GameVars_1.GameVars.scaleY;
        _this.add(title);
        _this.nextButton = new Phaser.Button(_this.game, GameConstants_1.GameConstants.GAME_WIDTH - 10, GameConstants_1.GameConstants.GAME_HEIGHT - 8, "texture_atlas_1", _this.onClickNext, _this);
        _this.nextButton.setFrames("btn_back_next", "btn_back_next", "btn_back_next");
        _this.nextButton.anchor.set(0, 1);
        _this.nextButton.scale.y = GameVars_1.GameVars.scaleY;
        _this.nextButton.scale.x = -1;
        _this.nextButton.input.pixelPerfectOver = true;
        _this.nextButton.forceOut = true;
        _this.add(_this.nextButton);
        _this.tutorialInfo = new TutorialInfo_1.TutorialInfo(_this.game, _this.index);
        _this.add(_this.tutorialInfo);
        return _this;
    }
    TutorialLayer.prototype.onClickNext = function () {
        this.index++;
        if (this.index === 4) {
            this.nextButton.visible = false;
            var playButton = new Phaser.Button(this.game, GameConstants_1.GameConstants.GAME_WIDTH / 2, GameConstants_1.GameConstants.GAME_HEIGHT - 20, "texture_atlas_1", this.onClickPlay, this);
            playButton.setFrames("btn_play", "btn_play", "btn_play");
            playButton.anchor.set(.5, 1);
            playButton.scale.y = GameVars_1.GameVars.scaleY;
            playButton.input.pixelPerfectOver = true;
            playButton.forceOut = true;
            this.add(playButton);
        }
        this.game.add.tween(this.tutorialInfo)
            .to({ alpha: 0 }, 250, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function () {
            this.tutorialInfo.destroy();
            this.tutorialInfo = new TutorialInfo_1.TutorialInfo(this.game, this.index);
            this.tutorialInfo.alpha = 0;
            this.add(this.tutorialInfo);
            this.game.add.tween(this.tutorialInfo)
                .to({ alpha: 1 }, 250, Phaser.Easing.Cubic.In, true);
        }, this);
        AudioManager_1.AudioManager.getInstance().playSound("btn_press");
    };
    TutorialLayer.prototype.onClickPlay = function () {
        this.game.state.start("BoardState", true, false);
        AudioManager_1.AudioManager.getInstance().playSound("btn_press");
    };
    return TutorialLayer;
}(Phaser.Group));
exports.TutorialLayer = TutorialLayer;
